/* eslint-disable camelcase */
import React, { useContext, useState } from 'react'
import {
  Footer,
  Search,
  StatusBox,
  StyledTable,
  TableCell,
  TableContainer,
  TableHeader,
} from './styled'
import { Input } from '../../../../components/common/Input'
import { Eye, MagnifyingGlass } from '@phosphor-icons/react'
import { Button } from '../../../../components/common/Button'
import useFilteredData from '../../../../hooks/searchHook'

export const OnlineEmployeesTable = ({ onclick, data }) => {
  const { filteredData, filterData } = useFilteredData(data)
  const [search, setSearch] = useState('')

  const occurrence_status_json = {
    ABERTO: 'Aguardando ação',
    EMPROGRESSO: `Em ocorrência`,
    FECHADO: 'Fechado',
  }

  const handleSubmit = (e) => {
    e.preventDefault()
  }

  const handleSearchChange = (e) => {
    setSearch(e.target.value)
    filterData(e.target.value)
  }

  const formatedData = (data) => {
    const date = data
    if (!date) {
      return ''
    }

    const fullDate = new Date(date)
    const hours = String(fullDate.getUTCHours()).padStart(2, '0')
    const minutes = String(fullDate.getUTCMinutes()).padStart(2, '0')

    return new Date(data).toLocaleTimeString()
  }

  return (
    <>
      <TableContainer>
        <div>
          <Search onSubmit={handleSubmit}>
            <span>Pesquisar</span>
            <Input.Root>
              <Input.Wrapper
                borderColor="#CECECE"
                backgroundColor="#F7F7F7"
                outlineColor=""
              >
                <Input.Content
                  id=""
                  onChange={handleSearchChange}
                  type="text"
                  value={search}
                  placeholder="Usuário"
                />
                <Input.Icon>
                  <MagnifyingGlass size={16} color="#494949" />
                </Input.Icon>
              </Input.Wrapper>
            </Input.Root>
          </Search>
        </div>

        <StyledTable>
          <thead>
            <tr>
              <TableHeader>Nome de usuário</TableHeader>
              <TableHeader>Posto</TableHeader>
              <TableHeader>Última ocorrência</TableHeader>
              <TableHeader>Status atual</TableHeader>
              <TableHeader>Retorno do sempre alerta</TableHeader>
              <TableHeader>Ver detalhes</TableHeader>
            </tr>
          </thead>
          <tbody>
            {data !== undefined &&
              data !== null &&
              data.length !== 0 &&
              filteredData?.map((data) => {
                const { Occurrences, AlwaysAlertMessages } = data

                return (
                  <tr key={data.id}>
                    <TableCell>{data.name}</TableCell>
                    <TableCell>{data.outpost}</TableCell>
                    <TableCell>
                      {Occurrences.length > 0
                        ? `#${Occurrences[0]?.code} - ${formatedData(
                            Occurrences[0]?.created_at,
                          )}`
                        : 'Sem ocorrências'}
                    </TableCell>
                    <TableCell>
                      {Occurrences[0]?.status === 'EMPROGRESSO' ? (
                        <StatusBox
                          status={
                            occurrence_status_json[Occurrences[0]?.status]
                          }
                        >
                          Em ocorrência - #{Occurrences[0].code}
                        </StatusBox>
                      ) : (
                        <StatusBox
                          status={
                            occurrence_status_json[Occurrences[0]?.status]
                          }
                        >
                          Em vigilância - Aguardando ação
                        </StatusBox>
                      )}
                    </TableCell>
                    <TableCell>
                      {AlwaysAlertMessages.length > 0 ? (
                        <>
                          <StatusBox status="Enviado">
                            {AlwaysAlertMessages[0].answered_at
                              ? `Respondido - ${formatedData(
                                  AlwaysAlertMessages[0].answered_at,
                                )}`
                              : `Enviado - ${formatedData(
                                  AlwaysAlertMessages[0].sent_at,
                                )}`}
                          </StatusBox>
                        </>
                      ) : (
                        <>
                          <StatusBox status="Não enviado">
                            Não enviado
                          </StatusBox>
                        </>
                      )}
                    </TableCell>
                    <TableCell>
                      <Button.Root
                        onClick={() => {
                          onclick(data.id)
                        }}
                        backgroundColor="#00517D"
                        type="button"
                      >
                        <Button.Content title="Ver detalhe" color="#fff" />
                        <Button.Icon padding="0">
                          <Eye size={20} color="#fff" weight="fill" />
                        </Button.Icon>
                      </Button.Root>
                    </TableCell>
                  </tr>
                )
              })}
          </tbody>
        </StyledTable>
        <Footer>
          <span>{`Listando ${filteredData.length} usuários`}</span>
        </Footer>
      </TableContainer>
    </>
  )
}
